<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      clearable
      :items="options"
      v-model="innerValue"
      item-text="text"
      item-value="value"
      @blur="emitBlur"
      :solo="solo"
      v-bind="resetProps"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    value: [String, Number],
    solo: Boolean,
    dense: Boolean,
    filterId: [String, Number],
    hideRoot: Boolean
  },
  data() {
    return {
      innerValue: this.value,
    };
  },

  async created() {
    await this.getAll();
  },

  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  methods: {
    ...mapActions("vaultFolder", ["getAll"]),

    emitBlur() {
      this.$emit("blur");
    },

    filterItems(value) {
      return value.indexOf(this.filterWord) !== 0;
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),

    resetProps() {
      return { ...this.$attrs };
    },

    categoryItems() {
      return this.$store.getters["vaultFolder/getAll"];
    },

    options() {
      let categoryItems = this.categoryItems.filter(category => {
        let stringAll = category.pathIds.join('|');
        return stringAll.indexOf(`${this.filterId}|`) === -1 && category.id != this.filterId;
      }).map((category) => {
        return {
          ids: category.pathIds,
          value: category.id,
          text: category.pathName,
        };
      })
      
     
      return [{ text: "Root", value: null }, ...categoryItems];
    },
  },
};
</script>